export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <div className="flex flex-wrap items-start justify-between gap-8">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_landing-builder-270/artifacts/g0s0yuk5_LuniPin%20%282%29.png"
              alt="Lunipin"
              className="h-10 w-auto object-contain"
            />
            <p className="mt-4 font-mono text-[11px] text-neutral-500 uppercase tracking-[0.2em]">
              A Workplace Intelligence Simulation
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-16 gap-y-4">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
                Formats
              </div>
              <div className="space-y-2 text-sm">
                <a href="#products" className="block text-neutral-300 hover:text-white">
                  Hunt Dhurandhar
                </a>
                <a href="#recognition" className="block text-neutral-300 hover:text-white">
                  Recognition Grand Slam
                </a>
                <a href="#crazy" className="block text-neutral-300 hover:text-white">
                  Crazy Sports
                </a>
              </div>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
                Contact
              </div>
              <div className="space-y-2 text-sm">
                <a
                  href="mailto:sanjaykidiyoor@lunipin.com"
                  className="block text-neutral-300 hover:text-white"
                  data-testid="footer-email"
                >
                  sanjaykidiyoor@lunipin.com
                </a>
                <a
                  href="tel:+919845739307"
                  className="block text-neutral-300 hover:text-white"
                  data-testid="footer-phone"
                >
                  +91 98457 39307
                </a>
                <span className="block text-neutral-500">www.lunipin.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
            © {year} Lunipin · All operations classified
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
            The game already exists. <span className="text-[#dc2626]">▌</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
